// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3OVRs","steps":"styles_steps__KVsgm","step_label":"styles_step_label__2cQhG","step_desc":"styles_step_desc__34sdK"};